import Chart from "react-google-charts";
import Icon1 from "../../../assets/images/dashborad/dashborad_4.png";
import Icon2 from "../../../assets/images/dashborad/dashborad_3.png";
import Icon3 from "../../../assets/images/dashborad/dashborad_2.png";
import Icon4 from "../../../assets/images/dashborad/dashborad_1.png";
import React from "react";
import HeaderBar from "../../../components/header/headerBar";

import "../../../assets/styles/admin/dashborad.scss";
interface Props {
  icon: string;
  title: string;
  value: string;
}
const DashboardPage = () => {
  const SubHeader: React.FC<Props> = ({ icon, title, value }) => {
    return (
      <div className="header-card">
        <div className="card-view">
          <div className="card-contant">
            <div>
              <img src={icon} />
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "10px",
              }}
            >
              <b>{title}</b>
              <div style={{ color: "#336CFB" }}>{value}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const dataChart = [
    ["", "Patients 2019", "Patients 2020"],
    ["2020-1", 140, 50],
    ["2020-2", 110, 70],
    ["2020-3", 210, 115],
    ["2020-4", 140, 120],
    ["2020-5", 160, 160],
    ["2020-6", 140, 170],
    ["2020-7", 50, 88],
    ["2020-8", 69, 100],
    ["2020-9", 70, 150],
    ["2020-10", 150, 60],
    ["2020-11", 220, 112],
    ["2020-12", 115, 169],
  ];

  return (
    <div className="dashborad">
      <HeaderBar title="DASHBOARD & REPORT" />
      <div className="body-page">
        <div className="contant">
          <div className="dashborad-header">
            <SubHeader title="Appointments" value="160" icon={Icon1} />
            <SubHeader title="New Patients" value="104" icon={Icon2} />
            <SubHeader title="Operations" value="24" icon={Icon3} />
            <SubHeader title="Hospital Earnings" value="$12,174" icon={Icon4} />
          </div>
        </div>

        <div className="duo-chart">
          <Chart
            chartType="AreaChart"
            width="100%"
            height="300px"
            loader={<div>Loading Chart</div>}
            data={dataChart}
            options={{
              title: "Hospital Survey",
              chartArea: { width: "70%" },
              series: {
                0: { curveType: "function" },
                1: { curveType: "function" },
              },
            }}
            legendToggle
          />
        </div>
        <div className="duo-chart">
          <Chart
            chartType="AreaChart"
            width="100%"
            height="300px"
            loader={<div>Loading Chart</div>}
            data={dataChart}
            options={{
              title: "Hospital Survey",
              chartArea: { width: "70%" },
              series: {
                0: { curveType: "function" },
                1: { curveType: "function" },
              },
            }}
            legendToggle
          />
        </div>
        <div className="duo-chart">
          <Chart
            chartType="AreaChart"
            width="100%"
            height="300px"
            loader={<div>Loading Chart</div>}
            data={dataChart}
            options={{
              title: "Hospital Survey",
              chartArea: { width: "70%" },
              series: {
                0: { curveType: "function" },
                1: { curveType: "function" },
              },
            }}
            legendToggle
          />
        </div>
      </div>
    </div>
  );
};
export default DashboardPage;
